<template>
  <v-app>
    <v-container class="pa-6 ma-0 d-flex flex-column gap-6 align-center main-d">
      <!-- section 1 -->
      <v-container class="pa-0 ma-0">
        <TaxPayerFilter
          @apply-filters="HandleApplyFilters"
          @apply-advanced-filters="HandleApplyAdvancedFilters"
        />
        <OverviewTaxPayer
          v-if="taxPayer"
          :tax-payer-data="taxPayer"
          :duration="changeDurationText"
        />
      </v-container>
      <!--section 2 -->
      <v-container fluid class="pa-0 ma-0">
        <v-row dense>
          <!--pending -->
          <v-col cols="12" md="6">
            <PendingInvoice :filter-chart="filter" :advance-filter="advancefilter" />
          </v-col>
          <!-- error-->
          <v-col cols="12" md="6">
            <ErrorInvoice :filter-chart="filter" :advance-filter="advancefilter" />
          </v-col>
        </v-row>
      </v-container>
      <!--section 3 -->
      <v-container fluid class="pa-0 ma-0">
        <v-row dense>
          <!--not sending -->
          <v-col cols="12" md="6">
            <NotSendInvoice :filter-chart="filter" :advance-filter="advancefilter" />
          </v-col>
          <!--success-->
          <v-col cols="12" md="6">
            <SuccessInvoice :filter-chart="filter" :advance-filter="advancefilter" />
          </v-col>
        </v-row>
      </v-container>
    </v-container>
  </v-app>
</template>

<script>
import TaxPayerFilter from "./partial/TaxPayerFilter.vue";
import OverviewTaxPayer from "./partial/OverviewTaxPayer.vue";
import PendingInvoice from "./partial/PendingInvoice.vue";
import ErrorInvoice from "./partial/ErrorInvoice.vue";
import NotSendInvoice from "./partial/NotSendInvoice.vue";
import SuccessInvoice from "./partial/SuccessInvoice.vue";
import AreaChart from "./partial/AreaChart.vue";

export default {
  name: "tax",
  components: {
    TaxPayerFilter,
    OverviewTaxPayer,
    PendingInvoice,
    ErrorInvoice,
    NotSendInvoice,
    SuccessInvoice,
    AreaChart,
  },
  data: () => ({
    taxPayer: null,
    loading: false,
  }),
  mounted() {
    this.getTaxData();
  },
  methods: {
    HandleApplyFilters(filters) {
      this.filter = filters;
      this.getTaxData(filters);
    },
    HandleApplyAdvancedFilters(filters) {
      this.advancefilter = filters;
      this.getTaxData(filters);
    },
    getTaxData(filters = {}) {
      const hasDefaultDate = !!filters.fromDate && !!filters.toDate;
      const Type = hasDefaultDate ? false : "month";
      let UserList = [];
      let ProductList = [];
      if (
        filters.UserList != undefined &&
        filters.UserList != null &&
        filters.UserList != []
      ) {
        UserList = filters?.UserList.map((u) => u.id);
      }
      if (
        filters.products != undefined &&
        filters.products != null &&
        filters.products != []
      ) {
        ProductList = filters?.products.map((p) => p.id);
      }
      var app = this;
      app.loading = true;
      this.$axios
        .get(this.$endpoint + "dashboard/charts/invoice-taxpayer-by-status", {
          params: {
            dateType: Type,
            fromDate: filters.fromDate || null,
            toDate: filters.toDate || null,
            status: filters.sellStatus || [],
            accountIds: filters.account || [],
            branch: filters.branch || [],
            UserList: UserList || [],
            minAmount: filters.amountRange?.[0] ?? null,
            maxAmount: filters.amountRange?.[1] ?? null,
            ProductList: ProductList || [],
            productGroup: filters.productGroup || null,
            entrepot: filters.entrepot || null,
            attachment: filters.attachments || null,
            receipt: filters.Receipt || null,
            category: filters.category || null,
            minAmountTax: filters.amountRangeTax?.[0] ?? null,
            maxAmountTax: filters.amountRangeTax?.[1] ?? null,
            invoice_status: filters.status || null,
          },
        })
        .then((response) => {
          let res = response.data.data;
          app.taxPayer = res;
          app.changeDurationText = res.flag;
        })
        .catch((err) => {
          app.loading = false;
        })
        .finally(() => {
          app.loading = false;
        });
    },
  },
};
</script>

<style scoped>
.main-d {
  min-width: 400px !important;
}
</style>
